// extracted by mini-css-extract-plugin
export default {"smooth":"TranscriptionList_smooth__tG8gl"};